/* import __COLOCATED_TEMPLATE__ from './insured-info.hbs'; */
import { dateFormat } from 'client-portal/utils/date-time';
import Component from '@glimmer/component';
import stateGroups from 'ember-simplepractice/utils/state-groups';

export default class SiteBillingOutOfNetworkFormInsuranceSectionInsuredInfo extends Component {
  stateGroups = stateGroups;
  dateFormat = dateFormat;
}
